import { z } from "zod"

// Version 1 ---------------------
export const ImageBaseSettingsV1 = z.object({
  altText: z.string(),
  src: z.string().optional(),
  initialStyles: z.object({}).passthrough().optional(),
})

export type TImageBaseSettingsV1 = z.infer<typeof ImageBaseSettingsV1>

export const ImageBaseElementV1 = z.object({
  id: z.string(),
  name: z.literal("imageBase"),
  settings: ImageBaseSettingsV1,
})

export type TImageBaseElementV1 = z.infer<typeof ImageBaseElementV1>

// Latest ---------------------
export const ImageBaseSettings = ImageBaseSettingsV1
export type TImageBaseSettings = TImageBaseSettingsV1
export const ImageBaseElement = ImageBaseElementV1
export type TImageBaseElement = TImageBaseElementV1
